<template>
  <div>
    <b-row class="m-text-deep">
      <b-col md="5">
        <div v-if="needDemo">
        <h4 class="mt-2">Choose Category:</h4>
        <div class="m-select-spinner" v-show="categories.length<= 1">
          <div class="m-spinner "></div>
        </div>
        <b-form-select v-model="demoType"
                       :select-size="selectFormSize"
                       :disabled="isAllHoseholds"
                       data-test="demo-select-category"
                       >
          <option v-for="item in categories" :value = "item.demoType">
            {{item.desc}}</option>
        </b-form-select>
        </div>

        <h4 class="mt-2">{{needDemo ? 'Audience Propensity:' : 'Choose Category:'}}</h4>
        <div class="m-select-spinner" v-show="columns.length === 0">
          <div class="m-spinner "></div>
        </div>
        <b-select v-model = "selectedColumn"
                  :select-size="selectFormSize"
                  :disabled="isAllHoseholds"
                  data-test="demo-select-column"
                  class="ttt"
                  placeholde="select demo">
          <option value=""  v-show="columns.length > 0">Please select some demo</option>
          <option v-for="item in columns"text-
                  :key = "item.ColumnName"
                  :value = "item.ColumnName">
            {{item.AttributeDesc}}</option>
        </b-select>
        <h4 class="mt-2">Choose Filter(s):</h4>
        <div class="m-select-spinner" v-show="(attributes.length=== 0 && selectedColumn.length > 0) ">
          <div class="m-spinner "></div>
        </div>

        <!-- black demo box -->
        <div v-show = "attributes.length=== 0 && selectedColumn.length == 0"
             class="input-box"
             :style = "{height: selectFromHeight}"/>
        <!--DemoInputType list box -->
        <b-select v-if="selectedColumnItem.DemoInputtype === 0 || selectedColumnItem.DemoInputtype === 8 || !selectedColumnItem"
                  v-model = "selectedAttributes"
                  :select-size="selectFormSize"
                  :disabled="isAllHoseholds"
                  class="demo-select"
                  data-test="demo-select-attribute"
                  multiple>
          <option v-for="item in attributes"
                  :value = "item" :disabled="item.AttributeValue === 'DoNotChooseThis'">
            {{item.AttributeValueDesc}}</option>
        </b-select>

        <div v-if="columnIsTextInput"
             class="input-box"
             :style = "{height: selectFromHeight}">
          <div v-if="attributes.length !== 0">
            <p>{{attributes[0].AttributeValueDesc}}</p>
              <b-row>
                <b-col><b-input v-model = "inputFrom"  class="input-box-input" size="sm" :placeholder="inputFromHolder"/></b-col>
                <b-col v-if="selectedColumnItem.DemoInputtype !== 9 && selectedColumnItem.DemoInputtype !== 6"><b-input v-model = "inputTo"  class="input-box-input" size="sm" :placeholder="inputToHolder"/></b-col>
              </b-row>
            <b-btn size="sm" @click="addDemos">Add</b-btn>
            <span class="m-error-text" v-show="inputError !== false">{{inputError}}</span>
          </div>
        </div>

        <!--DemoInputType RadioSelectBox -->
        <!--<div v-if="selectedColumnItem.DemoInputtype === 8" class="input-box"></div>-->
      </b-col>
      <b-col md="2" class="m-select-btn-box">
        <b-btn class="m-select-btn"
               size="sm"
               @click="addDemos()"
               data-test="demo-select-add"
               :disabled="isAllHoseholds" style="margin-top: 16px">
          Add</b-btn>
        <b-btn class="m-select-btn"
               size="sm"
               @click="deleteDemos()"
               data-test="demo-select-delete"
               :disabled="isAllHoseholds">
          Remove</b-btn>
        <b-btn class="m-select-btn"
               @click="cleanDemos()"
               size="sm"
               data-test="demo-select-clear"
               :disabled="isAllHoseholds">
          Remove All</b-btn>
      </b-col>
      <b-col md="5" rows="2">
        <h4 class="mt-2">Your Target Audience:</h4>
        <b-select v-model = "unSelectedDemos"
                  :select-size="20"
                  class="demo-select"
                  :disabled="isAllHoseholds"
                  multiple >
            <option v-for="item in selectedDemos"
              :value="item" :class="{'demos-column':item.type === 'column' }" class="demos-value">
              {{item.name}}
            </option>
        </b-select>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import notification from '@/components/common/notification'
  export default {
    props: {
      propDemoType: {
        type: Number,
        default: 1
      },
      specialDemoCategory: {
        type: [Number, Boolean],
        default: false
      },
      needDemo: {
        type: Boolean,
        default: false
      }
    },
    components: {
    },
    data () {
      return {
        categories: [
          {
            demoType: 18,
            desc: 'Automotive'
          },
          {
            demoType: 16,
            desc: 'Business'
          },
          {
            demoType: 15,
            desc: 'Consumer Packaged Goods'
          },
          {
            demoType: 14,
            desc: 'Communications'
          },
          {
            demoType: 19,
            desc: 'Credit Card'
          },
          {
            demoType: 17,
            desc: 'Financial Services'
          },
          {
            demoType: 3,
            desc: 'General'
          },
          {
            demoType: 4,
            desc: 'Health Care'
          },
          {
            demoType: 5,
            desc: 'Insurance'
          },
          {
            demoType: 6,
            desc: 'Investment Services'
          },
          {
            demoType: 7,
            desc: 'Media'
          },
          {
            demoType: 8,
            desc: 'Non-Profit'
          },
          {
            demoType: 9,
            desc: 'Political'
          },
          {
            demoType: 10,
            desc: 'Retail'
          },
          {
            demoType: 12,
            desc: 'Travel Entertainment'
          },
          {
            demoType: 13,
            desc: 'Technology'
          }
        ],
        selectedDemoType: 18,
        demoTypeInit: false,
        selectedColumn: '',
        selectedAttributes: [],
        unSelectedDemos: [],
        inputFrom: '',
        inputTo: '',
        inputError: ''
      }
    },
    watch: {
      '$route.params.listType' () {  // TODO@PONY
        let listType = parseInt(this.$route.params.listType)
        if (listType !== this.$store.state.order.listType) {
          this.selectedColumn = ''
        }
      }
    },
    computed: {
      selectFromHeight () {
        return this.needDemo ? '168px' : '238px'
      },
      selectFormSize () {
        return this.needDemo ? 5 : 9
      },
      demoType: {
        get () {
          if (this.needDemo) {
            return this.selectedDemoType
          } else {
            return this.propDemoType
          }
        },
        set (val) {
          if (this.selectedDemoType !== val) {
            this.selectedDemoType = val
            this.selectedColumn = ''
          }
        }
      },
      listType () {
        if (this.$store.state.order.ListType) {
          return this.$store.state.order.ListType
        } else {
          return 10
        }
      },
      inputFromHolder () {
        let dict = {
          0: '',
          1: 'YYYYMMDD',
          2: 'Interger or Amount',
          3: 'MMYYYY',
          4: 'YYYY',
          5: 'MM',
          6: 'SIC Code',
          7: 'String',
          8: 'radio',
          9: 'input or string'
        }
        if (dict.hasOwnProperty(this.selectedColumnItem.DemoInputtype)) {
          let str = dict[this.selectedColumnItem.DemoInputtype]
          let maxmin = ''
          if (this.selectedColumnItem.MinValue) {
            maxmin += 'Min:' + this.selectedColumnItem.MinValue
          }
          if (maxmin.length > 0) {
            maxmin += ';'
          }
          if (this.selectedColumnItem.MaxValue) {
            maxmin = 'Max:' + this.selectedColumnItem.MaxValue
          }
          if (maxmin.length > 0) {
            str += `(${maxmin})`
          }
          return str
        } else {
          return ''
        }
      },
      inputToHolder () {
        return this.inputFromHolder
      },
      selectedColumnItem () {
        if (this.selectedColumn.length !== 0 && this.columns.hasOwnProperty(this.selectedColumn)) {
          this.inputFrom = ''
          this.inputTo = ''
          this.inputError = ''
          return this.columns[this.selectedColumn]
        } else {
          return {}
        }
      },
      demos () {
        return this.$store.state.demo.demos
      },
      selectedDemos () {
        let demos = this.$store.getters['order/demoItems']
        let result = []
        for (let column of demos) {
          // hide quick pick , business type
          if ([2, 5, 4, 6].indexOf(column.DemoCategoryType) === -1) {
            result.push({
              type: 'column',
              columnName: column.ColumnName,
              name: column.AttributeName,
              demoCategoryType: column.DemoCategoryType
            })
            for (let value of column.Values) {
              result.push({
                type: 'value',
                attributeValue: value.AttributeValue,
                columnName: value.ColumnName,
                name: value.AttributeValueName,
                demoCategoryType: column.DemoCategoryType
              })
            }
          }
        }
        return result
      },
      columns () {
        if ((this.listType in this.demos) &&
          (this.demoType in this.demos[this.listType])) {
          return this.demos[this.listType][this.demoType]
        } else {
          this.getDemos()
          return []
        }
      },
      attributes () {
        if (this.selectedColumn.length !== 0 && this.columns.hasOwnProperty(this.selectedColumn)) {
          if (this.columns[this.selectedColumn].Values.length === 0) {
            this.getAttributes()
          }
          return this.columns[this.selectedColumn].Values
        } else {
          return []
        }
      },
      isAllHoseholds () {
        return this.$store.getters['order/isAllHoseholds']
      },
      columnIsTextInput () {
        return (this.selectedColumnItem.DemoInputtype >= 1 && this.selectedColumnItem.DemoInputtype <= 7) || this.selectedColumnItem.DemoInputtype === 9
      }
    },
    created () {
    },
    methods: {
      getDemos () {
        this.$http.post('PlaceOrder.aspx/GetDemoAttributesList', {
          demotype: this.demoType,
          listtype: this.listType
        }).then(resp => {
          let data = resp.body.d.DataSource
          this.$store.commit('demo/saveColumns', {
            listType: this.listType,
            demoType: this.demoType,
            data
          })
        })
      },
      getAttributes () {
        this.$http.post('PlaceOrder.aspx/GetDemoAttribute', {
          columnName: this.selectedColumn,
          listtype: this.listType
        }).then(resp => {
          let data = resp.body.d.DataSource.DemoValues
          if (resp.body.d.DataSource.DemoInputtype === 0 && data.length === 0) {
            data = [{
              AttributeValueDesc: 'No available option',
              AttributeValue: 'DoNotChooseThis'
            }]
          } else if (resp.body.d.DataSource.DemoInputtype === 9 && data.length === 0) {
            data = [{
              AttributeValue: null,
              AttributeValueName: null,
              ColumnName: resp.body.d.DataSource.ColumnName

            }]
          } else if (resp.body.d.DataSource.DemoInputtype === 6 && data.length === 0) {
            data = [{
              AttributeValue: null,
              AttributeValueName: null,
              ColumnName: resp.body.d.DataSource.ColumnName

            }]
          }
          this.$store.commit('demo/saveAttributes', {
            listType: this.listType,
            demoType: this.demoType,
            columnName: this.selectedColumn,
            demoCategory: resp.body.d.DataSource.DemoCategory,
            data
          })
        })
      },
      getAttrbiutesValue (columnName, val) {
        return {
          listType: this.listType,
          demoType: this.demoType,
          columnName: columnName,
          value: val
        }
      },
      addDemos () {
        let item = null
        // demoInputType 1, 2, 3, 4, 5, 6, 7, 9
        if (this.columnIsTextInput) {
          item = this.addDemoInput()
          if (item !== false) {
            item.DemoCategoryType = this.specialDemoCategory || 3
            this.$store.dispatch('order/addDemoByItem', item)
          }
        } else if (this.selectedAttributes.length === 0) {
          return false
        } else if (this.selectedColumnItem.DemoInputtype === 0 || this.selectedColumnItem.DemoInputtype === 8) {
          for (item of this.selectedAttributes) {
            // check if only select one value
            if (this.selectedColumnItem.DemoInputtype === 8 &&
              this.$store.getters['order/demoColumnIndex'](item.ColumnName, item.DemoCategory) !== -1) {
              notification.notice('warning', 'You can only choose one item for this category')
              return false
            }
            item.AttributeName = this.columns[this.selectedColumn].AttributeName
            item.AttributeDesc = this.columns[this.selectedColumn].AttributeDesc
            item.DemoCategoryType = 3
            if (this.specialDemoCategory) item.DemoCategoryType = this.specialDemoCategory
            this.$store.dispatch('order/addDemoByItem', item)
          }
        } else {
        }
      },
      checkIsNumber (val) {
        if (isNaN(val) || val === null || val === '') {
          this.inputError = 'Need Digital'
          return false
        }
      },
      checkInput1DayMonthYearVal (val) {
        if (val.length !== 8) {
          this.inputError = 'Need formate: YYYYMMDD'
          return false
        }

        let day = parseInt(val.substring(6, 8))
        let month = parseInt(val.substring(4, 6))
        let year = parseInt(val.substring(0, 4))

        if (year < 1000 || year > 2099 || month < 1 || month > 12 || day < 1 || day > 31 || isNaN(month) || isNaN(year) || isNaN(day)) {
          this.inputError = 'Need formate: YYYYMMDD'
          return false
        }
        return {
          day: val.substring(6, 8),
          month: val.substring(4, 6),
          year: val.substring(0, 4)
        }
      },
      checkInput2InterVal (val) {
        val = parseInt(val)
        if (isNaN(val)) {
          this.inputError = 'Need Number'
          return false
        }
        return val
      },
      checkInput3MonthYearVal (val) {
         // 3 month year
        if (val.length !== 6) {
          this.inputError = 'Need formate: MMYYYY'
          return false
        }
        let month = parseInt(val.substring(0, 2))
        let year = parseInt(val.substring(2, 6))
        if (year < 1000 || year > 2099 || month < 1 || month > 12 || isNaN(month) || isNaN(year)) {
          this.inputError = 'Need formate: MMYYYY'
          return false
        }
        return {month: val.substring(0, 2), year: val.substring(2, 6)}
      },
      checkInput4YearVal (val, rules) {
        // 4 year, datasource10 demographics Year Home Built, checked
        if (val.length !== 4) {
          this.inputError = 'Need formate: YYYY'
          return false
        }
        let year = parseInt(val)
        if (year < 1900 || year > 2099 || isNaN(year)) {
          this.inputError = 'Need formate: YYYY'
          return false
        }
        return year
      },
      checkInput5Month (val) {
        if (val.length !== 2) {
          this.inputError = 'Need formate: MM'
          return false
        }
        let month = parseInt(val)
        if (month < 1 || month > 12 || isNaN(month)) {
          this.inputError = 'Need formate: MM'
          return false
        }
        return val
      },
      checkInput7String (val) {
        if (val.length === 0) {
          this.inputError = 'Need String'
          return false
        }
        return val
      },
      checkToMoreFrom (from, to) {
        if (from > to) {
          this.inputError = 'First input is smaller than second'
          return false
        } else {
          return true
        }
      },
      checkMaxMin (from, to, type) {
        let max = this.selectedColumnItem.MaxValue
        let min = this.selectedColumnItem.MinValue

        if (max !== null) {
          if (from > max || to > max) {
            this.inputError = 'value must smaller than ' + max
          }
        }

        if (min !== null) {
          if (from < min || to < min) {
            this.inputError = 'value must bigger than ' + min
          }
        }
      },
      checkOneMaxMin (from) {
        let max = this.selectedColumnItem.MaxValue
        let min = this.selectedColumnItem.MinValue
        if (max !== null) {
          if (from > max) {
            this.inputError = 'value must smaller than ' + max
          }
        }

        if (min !== null) {
          if (from < min) {
            this.inputError = 'value must bigger than ' + min
          }
        }
      },
      addDemoInput () {
        this.inputError = ''
        let item = this.selectedColumnItem
        let from = null
        let to = null
        // check value fromate
        if (item.DemoInputtype === 1) {
          // Input DayMonthyear dataourece 40 data of publication
          from = this.checkInput1DayMonthYearVal(this.inputFrom)
          to = this.checkInput1DayMonthYearVal(this.inputTo)

          if (this.inputError === '') {
            this.checkToMoreFrom(`${from.year}${from.month}${from.day}`, `${to.year}${to.month}${to.day}`)
            this.checkMaxMin(`${from.year}${from.month}${from.day}`, `${to.year}${to.month}${to.day}`)
          }
        } else if (item.DemoInputtype === 2) {
          // InputInteger,  datasource10 audience propensities -> automotive -> Affinity fro a New
          from = this.checkInput2InterVal(this.inputFrom)
          to = this.checkInput2InterVal(this.inputTo)
        } else if (item.DemoInputtype === 3) {
          // InputMonthyear
          from = this.checkInput3MonthYearVal(this.inputFrom)
          to = this.checkInput3MonthYearVal(this.inputTo)
          if (this.inputError === '') {
            this.checkToMoreFrom(`${from.year}${from.month}`, `${to.year}${to.month}`)
            this.checkMaxMin(`${from.year}${from.month}`, `${to.year}${to.month}`)
          }
        } else if (item.DemoInputtype === 4) {
          // InputYear, datasource10 demographics Year Home Built
          from = this.checkInput4YearVal(this.inputFrom)
          to = this.checkInput4YearVal(this.inputTo)
        } else if (item.DemoInputtype === 5) {
          // inputMonth
          from = this.checkInput5Month(this.inputFrom)
          to = this.checkInput5Month(this.inputTo)
        } else if (item.DemoInputtype === 6) {
          // 6 SIC, datasource20 demographic SIC CODE
          // TODO@important I can't understood SIC CODE
          from = this.inputFrom
          // to = this.inputTo
        } else if (item.DemoInputtype === 7) {
          // 7 InputString, datasource170 demographics upload codes
          // TODO@important maybe it not string
          from = this.inputFrom
          to = this.inputTo
          from = this.checkInput7String(this.inputFrom)
          to = this.checkInput7String(this.inputTo)
        } else if (item.DemoInputtype === 8) {
          // RadioSelectBox ,  prod datasource 40 demo，residential/Business Selector
          // TODO@important I can't find this type
          from = this.inputFrom
          to = this.inputTo
        } else if (item.DemoInputtype === 9) {
          // InputIntegerSingle,  prod datasource 160 demo  Corporate Sales Volume Actual, dev dataSource 10 small office - home office
          from = this.inputFrom
          this.checkIsNumber(from)
          this.checkOneMaxMin(from)
        }

        // assignment
        if (this.inputError.length > 0) {
          return false
        } else if (item.DemoInputtype === 1) {
          item.AttributeValue = `${from.year}${from.month}${from.day}~${to.year}${to.month}${to.day}`
          item.AttributeValueName = `${from.year}${from.month}${from.day}~${to.year}${to.month}${to.day}`
        } else if (item.DemoInputtype === 3) {
          item.AttributeValue = `${from.year}${from.month}~${to.year}${to.month}`
          item.AttributeValueName = `${from.year}${from.month}~${to.year}${to.month}`
        } else if (item.DemoInputtype === 9) {
          item.AttributeValue = from
          item.AttributeValueName = from
        } else if (item.DemoInputtype === 6) {
          item.AttributeValue = from
          item.AttributeValueName = from
        } else {
          this.checkToMoreFrom(from, to)
          this.checkMaxMin(from, to)
          item.AttributeValue = `${from}~${to}`
          item.AttributeValueName = `${from} to ${to}`
        }
        if (this.inputError.length > 0) {
          return false
        } else {
          this.inputFrom = ''
          this.inputTo = ''
          return item
        }
      },
      cleanDemos () {
        this.$store.commit('order/clearDemos')
      },
      deleteDemos () {
        for (let item of this.unSelectedDemos) {
          this.$store.dispatch('order/deleteDemo', item)
        }
      }
    }
  }
</script>

<style scoped lang="scss">
.h3-t{
  color:$color-black;
  margin-top: 8px;
}
.demos-column.demos-value {
  color: $color-black;
  margin-left: 0; /* TODO@PONY no unifrom css */
  font-size: 0.9em;
}
.demos-value {
  margin-left: 16px;
}
.select-demo-col{
  padding: 0 8px;
}
  .box {
    padding-left: 8px;
    padding-right: 8px;
    display: block;
  }
  .input-box {
    display: block;
    width: 100%;
    height: 230px;
    padding: 0.375rem 0.75rem;
    font-size: 1rem;
    line-height: 1.5;
    color: #495057;
    background-color: $color-background;
    background-image: none;
    background-clip: padding-box;
    border: 1px solid #ced4da;
    border-radius: 0.25rem;
  }
  .input-box-input {
    margin-top: -8px;
    margin-bottom: 8px;
  }
  .m-error-text {
    font-size: 12px;
    font-weight: normal;
  }
</style>


// WEBPACK FOOTER //
// src/components/demo/MDemoSelectPC.vue